import { render, staticRenderFns } from "./dialogList.vue?vue&type=template&id=d57f4180"
import script from "./dialogList.vue?vue&type=script&lang=js"
export * from "./dialogList.vue?vue&type=script&lang=js"
import style0 from "./dialogList.vue?vue&type=style&index=0&id=d57f4180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports